import { render, staticRenderFns } from "./Min-Max-value.vue?vue&type=template&id=60943694"
import script from "./Min-Max-value.vue?vue&type=script&lang=js"
export * from "./Min-Max-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports